/**
 * A primeira visita vai para a /conheca, não para o login (22/10).
 *
 * Quem abre fintracking.com.br pela primeira vez e cai numa tela de login não
 * sabe o que é o app nem por que pagar. Então: sem sessão, no `/` puro, e sem
 * nunca ter passado pela /conheca nem entrado no app, vai para a /conheca.
 *
 * Quem NUNCA é mandado:
 * - quem tem sessão (entra direto, como sempre);
 * - quem já passou pela /conheca (o script de lá grava a marca) ou já entrou
 *   alguma vez (o app grava ao ver a sessão);
 * - quem chega com algo no endereço: a volta do login do Google, o link de
 *   "esqueci minha senha", os convites — tudo isso traz `?` ou `#`, e mandar
 *   embora perderia o que veio;
 * - a demonstração.
 *
 * O armazenamento pode estar bloqueado (janela anônima): aí ninguém é mandado,
 * porque sem a marca a pessoa voltaria à /conheca a cada visita.
 */
export const MARCA_JA_CONHECE = 'ja-conhece-o-fintracking';

export const deveIrParaConheca = (
  local: Pick<Location, 'pathname' | 'search' | 'hash'>,
  ler: (chave: string) => string | null,
): boolean => {
  if (local.pathname !== '/' || local.search || local.hash) return false;
  try {
    return ler(MARCA_JA_CONHECE) === null;
  } catch {
    return false;
  }
};

export const marcarQueJaConhece = (): void => {
  try { localStorage.setItem(MARCA_JA_CONHECE, '1'); } catch { /* bloqueado: segue sem */ }
};

export const lerArmazenamento = (chave: string): string | null => {
  // Sem localStorage utilizável, lança: `deveIrParaConheca` trata como "não manda".
  localStorage.setItem('__teste__', '1');
  localStorage.removeItem('__teste__');
  return localStorage.getItem(chave);
};
